import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function HelpCircle($$anchor, $$props) {
	const iconNode = [
		["circle", { "cx": "12", "cy": "12", "r": "10" }],
		["path", { "d": "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }],
		["path", { "d": "M12 17h.01" }]
	];

	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiSGVscENpcmNsZS5zdmVsdGUiXSwic291cmNlc0NvbnRlbnQiOlsiPHNjcmlwdCBsYW5nPVwidHNcIj5cbiAgaW1wb3J0IEljb24gZnJvbSAnLi9JY29uLnN2ZWx0ZSc7XG4gIGNvbnN0IGljb25Ob2RlOiBbc3RyaW5nLCBSZWNvcmQ8c3RyaW5nLCBzdHJpbmc+XVtdID0gW1tcImNpcmNsZVwiLCB7IFwiY3hcIjogXCIxMlwiLCBcImN5XCI6IFwiMTJcIiwgXCJyXCI6IFwiMTBcIiB9XSwgW1wicGF0aFwiLCB7IFwiZFwiOiBcIk05LjA5IDlhMyAzIDAgMCAxIDUuODMgMWMwIDItMyAzLTMgM1wiIH1dLCBbXCJwYXRoXCIsIHsgXCJkXCI6IFwiTTEyIDE3aC4wMVwiIH1dXTtcbiAgbGV0IHJlc3QgPSAkcHJvcHMoKTtcbjwvc2NyaXB0PlxuPEljb24ge2ljb25Ob2RlfSB7Li4ucmVzdH0gLz5cbiJdLCJtYXBwaW5ncyI6Ijs7T0FDUyxJQUFJLE1BQU0sZUFBZTs7c0RBRGxDLENBQUM7T0FFTyxRQUE0QztHQUFLLFFBQVEsSUFBSSxJQUFJLEVBQUUsSUFBSSxFQUFFLElBQUksRUFBRSxJQUFJLEVBQUUsR0FBRyxFQUFFLElBQUk7R0FBTSxNQUFNLElBQUksR0FBRyxFQUFFLHNDQUFzQztHQUFNLE1BQU0sSUFBSSxHQUFHLEVBQUUsWUFBWTs7O0tBQzVMLElBQUk7Ozs7Ozs7O1FBRVcsSUFBSTs7QUFEMUIsQ0FBQyJ9